// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSciencePlantSeedlingSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17 6h3c.552 0 1.01.45.926.997C20.432 10.23 17.519 12 14 12h-1v1.063a7.995 7.995 0 0 1 6.39 4.876 8 8 0 0 1 .547 2.064c.07.548-.385.997-.937.997H5c-.553 0-1.007-.45-.938-.997A8 8 0 0 1 11 13.063V10h-1a7.002 7.002 0 0 1-6.93-6.003C2.992 3.45 3.448 3 4 3h3c2.965 0 4.911 1.843 5.657 4.447C13.671 6.497 15.134 6 17 6z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSciencePlantSeedlingSolid;
